import type { ReactNode } from "react";
import type { FormControlProps } from "@mui/material";
import { FormControl, MenuItem, Select, Skeleton } from "@mui/material";
import { useCatalogue } from "providers";
import AllMetiersCode from "constants/AllMetiersCode";

interface MetiersInputProps extends FormControlProps {}

function MetierInput({ ...formControlProps }: Readonly<MetiersInputProps>): ReactNode {
  const { selectedMetierId, setSelectedMetierId, metiers, isMetiersLoading } = useCatalogue();

  if (isMetiersLoading) {
    return <Skeleton width={250} height={40} sx={{ transform: "none" }} />;
  }

  return (
    <FormControl size="small" sx={{ minWidth: "250px", background: "white" }} {...formControlProps}>
      <Select
        // Pour éviter les erreurs console de valeur sélectionnée non disponible avant
        // que les métiers soient chargés
        value={isMetiersLoading ? "" : selectedMetierId}
        onChange={(event) => {
          setSelectedMetierId(event.target.value);
        }}>
        {isMetiersLoading ? (
          <Skeleton sx={{ marginX: 2 }} />
        ) : (
          metiers.map((metier) => (
            <MenuItem key={metier.id} value={metier.id}>
              {metier.libelle}
            </MenuItem>
          ))
        )}
        {!isMetiersLoading && <MenuItem value={AllMetiersCode}>Tous les métiers</MenuItem>}
      </Select>
    </FormControl>
  );
}

export default MetierInput;
